import { PasswordScoreColorEnum } from '@/constants/password-score.constants'

export function getPasswordStrengthColor (value) {
  switch (value) {
    case 0:
      return { percentage: 10, color: PasswordScoreColorEnum[0] }
    case 1:
      return { percentage: 25, color: PasswordScoreColorEnum[25] }
    case 2:
      return { percentage: 50, color: PasswordScoreColorEnum[50] }
    case 3:
      return { percentage: 75, color: PasswordScoreColorEnum[75] }
    case 4:
      return { percentage: 100, color: PasswordScoreColorEnum[100] }
    default:
      return { percentage: 0, color: PasswordScoreColorEnum[0] }
  }
}



// WEBPACK FOOTER //
// ./src/utilities/passwordstrength.helper.js